import React, { useState } from "react";

function UploadImage({ width, onFileSelect }) {
  const uploadBoxHeight = width / 3; // Set the height of the upload field
  const [dragActive, setDragActive] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState(""); // State for error message

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragActive(false);
    if (event.dataTransfer.files.length > 0) {
      validateFile(event.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      validateFile(event.target.files[0]);
    }
  };

  const openFileDialog = () => {
    document.getElementById(`fileInput-${width}`).click();
  };

  const validateFile = (file) => {
    const validImageTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
    if (validImageTypes.includes(file.type)) {
      setSelectedFile(file);
      setErrorMessage(""); 
      onFileSelect && onFileSelect(file); // ✅ Return file to parent
    } else {
      setSelectedFile(null);
      setErrorMessage("Please select an image");
    }
  };

  return (
    <div
      style={{
        ...styles.uploadBox,
        width: `${width}px`,
        height: `${uploadBoxHeight}px`,
        borderColor: dragActive ? "#007bff" : "#ccc",
      }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={openFileDialog}
    >
      <input
        type="file"
        id={`fileInput-${width}`}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      {/* Title inside the box at the top */}
      <div style={styles.titleContainer}>
        <h3 style={styles.title}>Layout image:</h3>
      </div>

      {/* Dynamic Text: Default, Success (Green), or Error (Red) */}
      <div style={styles.textContainer}>
        {errorMessage ? (
          <p style={styles.errorText}>{errorMessage}</p> // ❌ Red text when invalid file selected
        ) : selectedFile ? (
          <p style={styles.successText}>Selected: {selectedFile.name}</p> // ✅ Green text when valid image selected
        ) : (
          <p>Drag Image of layout here or <span style={styles.clickText}>click to upload</span></p> // 🔹 Default text
        )}
      </div>
    </div>
  );
}

const styles = {
  uploadBox: {
    border: "2px dashed #ccc",
    display: "flex",
    flexDirection: "column", // Stack title and text inside the box
    alignItems: "center",
    justifyContent: "space-between", // Keeps title at top & text centered
    textAlign: "center",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "border-color 0.3s",
    backgroundColor: "#f9f9f9",
    fontFamily: "'Times New Roman', sans-serif",
    padding: "10px",
  },
  titleContainer: {
    width: "100%",
    paddingTop: "5px", // Pushes title slightly down
    borderBottom: "1px solid #ccc", // Creates a visual separation
    textAlign: "center",
  },
  title: {
    fontSize: "18px",
    fontWeight: "bold",
    fontFamily: "'Times New Roman', sans-serif",
    margin: "0",
  },
  textContainer: {
    flex: 1, // Ensures text stays centered below the title
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "10px",
  },
  successText: {
    fontSize: "14px",
    color: "#228B22", // ✅ Green text for valid images
    fontWeight: "bold",
  },
  errorText: {
    fontSize: "14px",
    color: "red", // ❌ Red text for invalid files
    fontWeight: "bold",
  },
  clickText: {
    fontWeight: "bold",
    color: "#007bff",
  },
};

export default UploadImage;
